import _ from 'lodash';
import { STATUS_CODE } from './constants';

export const getErrorValidateWithId = (msgValidate, data, path) => {
  const index = _.findIndex(msgValidate, ['work_id', data.id]);
  if (index > -1) {
    return _.get(msgValidate[index], `message.${path}`);
  }
  return null;
};

export const handleResetFieldTreeWorks = (
  grid,
  handlePushParam,
  context,
  error
) => {
  switch (error.status) {
    case STATUS_CODE.notFound:
      const v = grid.collectionView;
      v.editItem(v.currentItem);
      v.currentItem['field_tree_id'] = null;
      v.currentItem['company_name'] = '';
      v.currentItem['is_data_changed']['field_tree_id'] = true;

      v.currentItem['job_id'] = null;
      v.currentItem['job_name'] = '';
      v.currentItem['is_data_changed']['job_id'] = true;

      v.currentItem['foreman_user_id'] = null;
      v.currentItem['foreman_user_name'] = '';
      v.currentItem['is_data_changed']['foreman_user_id'] = true;
      v.commitEdit();
      handlePushParam(context.item, 'field_tree_id');
      break;
    case STATUS_CODE.internalServerError:
      console.error(
        'request.js requestWithToken',
        'ネットワークエラー 500 です',
        JSON.stringify(error)
      );
      window.location.replace('/error-500');
      break;
    case STATUS_CODE.serviceUnavailable:
      window.location.replace('/');
      break;
    default:
      window.location.replace('/error-500');
      break;
  }
};


// WEBPACK FOOTER //
// ./src/utilities/works.js